import { Toast } from "antd-mobile";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CustomTable, Filter, FilterTag } from "../../../../../components";
import { getLastSixWeeks } from "../../../../../plugins/monthList";
import { moneyFormat } from "../../../../../plugins/numberFormat";
import { getCurrency, getUserCurrency } from "../../../../../plugins/utils";
import { filterKeyWithdrawData } from "../../enumerations/filterKeyEnum";
import { filterSetupWithdrawData } from "../../enumerations/filterSetupEnum";
import { withdrawStatusEnum } from "../../enumerations/transactionStatusEnum";
import { useCancelWithdraw, useGetWithdrawList } from "../../hooks/trade.hooks";
import styles from "./style.module.scss";
import "./style.scss";

const CURRENCY = getCurrency();
const USER_CURRENCY = getUserCurrency();
const LAST_SIX_WEEKS = getLastSixWeeks();

const Withdraw = () => {
  const { t } = useTranslation();

  const { mutate: cancelWithdraw } = useCancelWithdraw();
  const handleCancelWithdraw = async (id) => {
    await cancelWithdraw(
      { id: id },
      {
        onSuccess: () =>
          Toast.show({
            icon: "success",
            content: t("normal.isSent"),
          }),
      },
      {
        onError: (error) => {
          Toast.show({
            icon: "fail",
            content: error,
          });
        },
      },
    );
  };

  const renderFunctionButton = (data) => {
    return null;
    // if (data.status === withdrawStatus.APPLY) {
    //   return (
    //     <div className={styles.buttonBlue} onClick={() => handleCancelWithdraw(data.id)}>
    //       {t("normal.cancel")}
    //     </div>
    //   );
    // }
    // return <div className={styles.buttonDisabled}>{t("normal.cancel")}</div>;
  };

  const columns = [
    {
      title: t("tradeRecord.table.serialNumber"),
      dataIndex: "index",
      width: 60,
      align: "center",
      render: (text, record, index) => <>{index + 1}</>,
    },
    {
      title: t("normal.time"),
      width: 150,
      align: "center",
      dataIndex: "created_at",
    },
    {
      title: t("tradeRecord.table.orderNo"),
      width: 200,
      align: "center",
      dataIndex: "trans_id",
    },
    {
      title: `${t("tradeRecord.table.comission")} (${t(`global.currency.${CURRENCY}`)})`,
      width: 160,
      dataIndex: "trade_amount",
      align: "center",
      render: (text, record, index) => <>{moneyFormat(text)}</>,
    },
    {
      title: t("tradeRecord.table.exchangeRate"),
      width: 120,
      dataIndex: "exchange_rate",
      align: "center",
      render: (text, record, index) => (
        <>{`1 ${record.trans_currency} : ${record.exchange_rate} ${record.to_currency}`}</>
      ),
    },
    {
      title: `${t("tradeRecord.table.actualTransfer")} (${t(`global.currency.${USER_CURRENCY}`)})`,
      width: 160,
      dataIndex: "exchanged_amount",
      align: "center",
      render: (text, record, index) => <>{moneyFormat(text)}</>,
    },
    {
      title: t("tradeRecord.table.status"),
      dataIndex: "status",
      width: 80,
      align: "center",
      render: (text, record, index) => {
        const _status = withdrawStatusEnum.find((stat) => stat.value === parseInt(text));
        if (!_status) return "-";
        return (
          <div className={`${_status.key}`}>
            {_status.is_translation ? t(`${_status.label}`) : _status.label}
          </div>
        );
      },
    },
    {
      title: t("normal.remark"),
      width: 100,
      align: "center",
      dataIndex: "remark",
      render: (text, record, index) => <>{text || "-"}</>,
    },
    {
      title: t("normal.operation"),
      dataIndex: "operation",
      fixed: "right",
      width: 60,
      align: "center",
      render: (text, record, index) => <>{renderFunctionButton(record)}</>,
    },
  ];
  const [months, setMonths] = useState([]);
  const [weeks, setWeeks] = useState(LAST_SIX_WEEKS);
  const [filterDefaultValue, setFilterDefaultValue] = useState({
    [filterKeyWithdrawData.PERIOD_WEEK]: LAST_SIX_WEEKS[0]?.value,
    [filterKeyWithdrawData.STATUS]: null,
  });
  const [filterValue, setFilterValue] = useState({
    [filterKeyWithdrawData.PERIOD_WEEK]: LAST_SIX_WEEKS[0]?.value,
    [filterKeyWithdrawData.STATUS]: null,
  });

  const [localData, setLocalData] = useState([]);

  const {
    data: withdrawData,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
    isLoading,
    isError,
  } = useGetWithdrawList({
    params: {
      ...filterValue,
      period_date: filterValue[filterKeyWithdrawData.PERIOD_WEEK]?.split("~")[0],
    },
    options: {
      enabled: filterValue[filterKeyWithdrawData.PERIOD_WEEK] !== null,
      getNextPageParam: (lastPage, pages) => {
        if (pages.length < lastPage.last_page) {
          return pages.length + 1;
        } else {
          return undefined;
        }
      },
    },
  });

  const loadMore = () => {
    if (isFetchingNextPage === false && localData.length > 0) {
      fetchNextPage();
    }
  };

  useEffect(() => {
    if (withdrawData) {
      const page_length = withdrawData.pages.length;
      if (page_length <= 1) {
        setLocalData([...withdrawData.pages[0].data]);
      } else {
        setLocalData((prevState) => {
          return [...prevState, ...withdrawData.pages[page_length - 1].data];
        });
      }
    }
  }, [withdrawData]);

  const onHandleSearch = () => {};

  return (
    <div className={`${styles.container} withdraw-container`}>
      <Filter
        filterSetup={filterSetupWithdrawData}
        filterValue={filterValue}
        filterDefaultValue={filterDefaultValue}
        setFilterValue={setFilterValue}
        //If data loaded from API, add api data here
        apiValue={{
          [filterKeyWithdrawData.PERIOD_WEEK]: {
            value_enum: weeks,
          },
        }}
        onReset={() => {
          //if need some aditional reset logic in the page
          console.debug("RESET FILTER");
        }}
        onSubmitSearch={onHandleSearch}
      />
      <FilterTag
        filterSetup={filterSetupWithdrawData}
        filterValue={filterValue}
        filterDefaultValue={filterDefaultValue}
        setFilterValue={setFilterValue}
        apiValue={{
          [filterKeyWithdrawData.PERIOD_WEEK]: {
            value_enum: weeks,
          },
        }}
        refreshSearch={onHandleSearch}
      />
      {isLoading ? (
        ""
      ) : isError ? (
        ""
      ) : (
        <CustomTable
          columns={columns}
          dataSource={localData}
          hasMore={hasNextPage}
          loadMore={loadMore}
          showInifineScroll={true}
        />
      )}
    </div>
  );
};

export default Withdraw;
